/** "5 minutes ago" without date-fns — uses Intl.RelativeTimeFormat. */
export function formatTimeAgo(isoString) {
  const then = new Date(isoString).getTime();
  if (Number.isNaN(then)) return "";
  const diffSec = Math.round((then - Date.now()) / 1000);
  const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });
  const divisions = [
    { unit: "year", seconds: 31536000 },
    { unit: "month", seconds: 2592000 },
    { unit: "week", seconds: 604800 },
    { unit: "day", seconds: 86400 },
    { unit: "hour", seconds: 3600 },
    { unit: "minute", seconds: 60 },
    { unit: "second", seconds: 1 },
  ];
  for (const { unit, seconds } of divisions) {
    if (Math.abs(diffSec) >= seconds || unit === "second") {
      const value = Math.trunc(diffSec / seconds);
      return rtf.format(value, unit);
    }
  }
  return "";
}